//Firebase
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore/lite'
import { db } from '@/main'

//Mixins
import eventCategories from '../eventCategories'

export default {
  mixins: [eventCategories],
  data: () => ({
    events: [],
  }),
  mounted() {
    this.getEvents()
  },
  methods: {
    async getEvents() {
      const eventCol = collection(db, 'belegungsplan')
      const q = query(eventCol, where('approved', '==', true), limit(100))
      const eventSnapshot = await getDocs(q)
      const eventList = eventSnapshot.docs.map((doc) => doc.data())

      eventList.forEach((item) => {

        if (Array.isArray(item.category)) {
          for (let i = 0; i < item.category.length; i++) {
            const event = {
              name: item.name,
              start: item.start,
              end: item.end,
            }
            event.category = this.categories[i]
            this.events.push(event)
          }
        }
        else {
          const event = {
            name: item.name,
            start: item.start,
            end: item.end,
            category: this.categories[item.category]
          }
          this.events.push(event)
        }
      })
    }
  }

}
